// extracted by mini-css-extract-plugin
export default {"box":"errorPage_box__bzYG2","msgBox":"errorPage_msgBox__Wiuxe","msgBox__msg":"errorPage_msgBox__msg__G3ga2","btn":"errorPage_btn__QohZf"};